import React from 'react';
import { useListContext } from 'react-admin';
import BaseDownloadButton from 'src/components/common/BaseDownloadButton';
import { FILTER_EMPTY_VALUE } from 'src/constants';

interface DownloadReportButtonProps {
    pageUrl: string;
    label?: string;
    fallbackEducationCenterId?: string | number;
}

const DownloadReportButton: React.FC<DownloadReportButtonProps> = ({ pageUrl, label, fallbackEducationCenterId }) => {
    const { filterValues } = useListContext();
    const selectedCenterRaw =
        filterValues?.educationCenterId != null ? filterValues.educationCenterId : fallbackEducationCenterId;
    const educationCenterId =
        selectedCenterRaw === FILTER_EMPTY_VALUE || selectedCenterRaw == null ? undefined : selectedCenterRaw;
    const educationLevel = filterValues.educationLevel === FILTER_EMPTY_VALUE ? undefined : filterValues.educationLevel;

    return (
        <BaseDownloadButton
            pageUrl={pageUrl}
            label={label}
            params={{
                educationCenterId,
                ...(pageUrl === 'children' && { educationLevel })
            }}
            dateDefaults={{
                startDate: filterValues.startDate,
                endDate: filterValues.endDate
            }}
        />
    );
};

export default DownloadReportButton;
